import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/colombo.webp',
  './images/C1.webp',
  './images/C2.webp',
  './images/C3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Colombo, the vibrant capital of Sri Lanka, offers an exciting mix of modern urban life, colonial charm, and rich cultural experiences.

Key highlights include:

• Port City Colombo – A futuristic oceanfront development with modern architecture, parks, entertainment zones, and upcoming luxury residences.
• Galle Face Green – A seaside urban park perfect for evening strolls and street food.
• Nelum Kuluna (Lotus Tower) – South Asia’s tallest tower, featuring observation decks, restaurants, and panoramic city views.
• Colombo National Museum – The largest museum in Sri Lanka, showcasing the island’s fascinating history and heritage.
• Sri Lanka Planetarium – An educational and entertaining venue for astronomy enthusiasts and families.
• Shopping Malls – Majestic City, One Galle Face Mall, and Colombo City Centre offer international brands, local boutiques, and dining options.
• Diverse Food Scene – From street food to gourmet dining, enjoy Sri Lankan, Indian, Chinese, Western, and fusion cuisines across the city.
• Nightlife – Trendy bars, rooftop lounges, nightclubs, and live music venues create a vibrant night culture.
• Five-Star Hotels – Luxurious stays at Shangri-La, Cinnamon Grand, Taj Samudra, and Hilton Colombo with exceptional service and amenities.
• Cultural Diversity – A melting pot of religions and communities with temples, churches, mosques, and festivals.
• Urban Aesthetics – Wide boulevards, colonial architecture, lakeside views, and business hubs blend heritage and modernity.

Colombo is the gateway to Sri Lanka's charm, offering a cosmopolitan experience for business travelers, culture seekers, and leisure tourists alike.`,

    zh: `科伦坡是斯里兰卡充满活力的首都，融合了现代都市生活、殖民风情和丰富的文化体验。

主要亮点包括：

• 科伦坡港口城市 – 一个面向未来的海滨开发项目，设有现代建筑、公园、娱乐区和即将建成的豪华住宅。
• 加勒菲斯绿地 – 海边的城市公园，适合傍晚散步和享受街头美食。
• 莲花塔（Nelum Kuluna） – 南亚最高的塔楼，设有观景台、餐厅和壮观的城市全景。
• 国家博物馆 – 斯里兰卡最大的博物馆，展示岛屿丰富的历史和文化遗产。
• 天文馆 – 教育与娱乐相结合，适合家庭和天文爱好者。
• 购物中心 – Majestic City、One Galle Face 和 Colombo City Centre 提供国际品牌、本地精品和美食选择。
• 多样美食 – 从街头小吃到高端餐厅，应有尽有，包括斯里兰卡、印度、中国、西餐和融合菜系。
• 夜生活 – 时尚酒吧、屋顶酒廊、夜总会和现场音乐场所，营造热闹氛围。
• 五星级酒店 – 香格里拉、肉桂大酒店、塔吉萨穆德拉和希尔顿等提供豪华住宿和顶级服务。
• 多元文化 – 多宗教和族群交融，寺庙、教堂、清真寺和节日共同构成文化风景。
• 城市美学 – 宽阔大道、殖民建筑、湖畔风光与现代商务区完美融合。

科伦坡是斯里兰卡魅力的门户，为商务、文化和休闲游客提供独特的都市体验。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/colombo.webp"  className="travel-image2" />
          <img src="./images/C1.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Colombo</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Colombo</h2>
          <p className="carousel-subheading">Luxury, culture, and city vibes in one place</p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
